import {appAPI} from "../../../api";

const verificationPath = `/email-verification`;

export interface ISendCodeData {
    email: string;
    purpose: "registration" | "password_reset" | "email_change";
}

export interface ICheckCodeData extends ISendCodeData {
    code: string;
}

export const emailVerificationAPI = {
    sendCode: async (data: ISendCodeData) => {
        try {
            const res = await appAPI.post(`${verificationPath}/send-code`, data);
            return res.data;
        } catch (error: any) {
            throw new Error(
                error.response?.data?.message ||
                `Ошибка сервера: ${error.response?.status} ${error.response?.statusText}`,
            );
        }
    },
    checkCode: async (data: ICheckCodeData) => {
        try {
            const res = await appAPI.post(`${verificationPath}/check-code`, data);
            return res.data;
        } catch (error: any) {
            throw new Error(
                error.response?.data?.message ||
                `Ошибка сервера: ${error.response?.status} ${error.response?.statusText}`,
            );
        }
    },
};